import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Select,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { VARIANT, WHITE } from "../../../../constants/colors";
import Pagination from "../../../../defaultComponents/pagination";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import moment from "moment";
import { dateForList } from "../../../../constants/dataFormat";
import { FaEye, FaListAlt, FaTrashAlt } from "react-icons/fa";
import ModalCancelamentoAssinatura from "./modalCancelamentoAssinatura";
import { useNavigate } from "react-router";
import VendasRecorrentesApi from "../../../../services/vendasRecorrentesApi";
import ViewModalAssinaturas from "./viewModalAssinaturas";
import ModalUltimasCobrancas from "./modalUltimasCobrancas";
import { customColors } from "../../../../atoms/customColors";

interface IListVendasRecorrentes {
  id: number;
  idCliente: number;
  idAssinatura: string;
  idSeller: string;
  idBuyer: string;
  idPlano: string;
  dataProximaCobranca: string;
  dataUltimaTransacao: string;
  statusUltimaTransacao: string;
  dataExpiracao: string;
  valor: number;
  ativo: boolean;
  idCartao: string;
  plano: {
    id: number;
    nome: string;
    descricao: string;
    frequencia: string;
    duracao: number;
    intervalo: number;
    tolerancia: null;
    valor: number;
    taxa: number;
    idCliente: number;
    idPlano: string;
  };
  cliente: {
    id: number;
    nome: string;
    sobrenome: string;
    saldo: number;
    ativo: boolean;
    cnpj: string;
    isCnpj: boolean;
    razaoSocial: string;
    nomeFantasia: string;
    email: string;
    idPlano: number;
    idTarifa: number;
    idPromocao: number;
    idProjeto: number;
    idRede: number;
    dataNascProprietario: string;
    apiout: boolean;
  };
}

function TableVendasRecorrentes({ idCliente }: any) {
  const [assinaturas, setAssinaturas] = useState(Array<IListVendasRecorrentes>);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openCobrancas, setOpenCobrancas] = useState(false);
  const [itemToDetail, setItemToDetail] = useState(
    {} as IListVendasRecorrentes
  );

  const colors = useRecoilState(customColors)[0];

  const refresh = useRecoilState(refreshGlobal)[0];

  const navigate = useNavigate();

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages]);

  async function getListaVendasRecorrentes() {
    try {
      setLoading(true);
      const response = await VendasRecorrentesApi.getListaVendasRecorrentes(
        currentPage,
        pageSize,
        idCliente
      );
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      // console.log("response", response.data);
      setAssinaturas(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    getListaVendasRecorrentes();
  }, [refresh, currentPage, pageSize, idCliente]);

  return (
    <>
      <Flex justify="center" mb={4}>
        <Text fontWeight={"bold"} fontSize={"20px"}>
          Lista de Assinaturas
        </Text>
      </Flex>
      {!loading ? (
        <Flex flexDir={"column"}>
          <TableContainer
            overflowY={"auto"}
            overflowX={"auto"}
            h={"64vh"}
            w={"84vw"}
          >
            <Table variant="striped">
              <Thead h="60px" zIndex={1} position="sticky" top="0">
                <Tr>
                  <Th
                    borderRadius={"8px 0 0 8px"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    ID
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Cliente
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Plano
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data Primeira Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data ùltima Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Status Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={WHITE}>
                    Ativo
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Taxa Primeira Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor
                  </Th>
                  <Th
                    borderRadius={"0 8px 8px 0"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {assinaturas ? (
                  assinaturas.map((item, index) => {
                    return (
                      <Tr key={index}>
                        {/* id interno da assinatura: e por ele que o lojista
                            identifica a assinatura ao abrir chamado */}
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.id}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.cliente?.isCnpj === true
                            ? CaptionFormater(item?.cliente?.razaoSocial)
                            : `${CaptionFormater(
                                item?.cliente?.nome
                              )} ${CaptionFormater(item?.cliente?.sobrenome)}`}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {CaptionFormater(item?.plano?.nome)}
                        </Td>

                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.dataProximaCobranca
                            ? moment(item.dataProximaCobranca).format(
                                dateForList
                              )
                            : ""}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.dataUltimaTransacao
                            ? moment(item.dataUltimaTransacao).format(
                                dateForList
                              )
                            : ""}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.statusUltimaTransacao
                            ? item?.statusUltimaTransacao
                            : ""}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.ativo ? "Sim" : "Não"}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.plano?.taxa
                            ? ToLocaleFormat(item.plano.taxa / 100)
                            : "R$ 0,00"}
                        </Td>

                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          {item?.plano?.valor
                            ? ToLocaleFormat(item.plano.valor / 100)
                            : "R$ 0,00"}
                        </Td>
                        <Td
                          color={item.ativo ? "inherit" : "red"}
                          fontWeight={item.ativo ? "normal" : "bold"}
                        >
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={colors.BLUEMONEDDBUTTONS}
                              color={colors.WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              <MenuItem
                                onClick={() => {
                                  setOpenView(true);
                                  setItemToDetail(item);
                                }}
                                icon={<FaEye />}
                              >
                                Visualizar Assinatura
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  setOpenDelete(true);
                                  setItemToDetail(item);
                                }}
                                icon={<FaTrashAlt />}
                              >
                                Cancelar Assinatura
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  setItemToDetail(item);
                                  setOpenCobrancas(true);
                                }}
                                icon={<FaListAlt />}
                              >
                                Últimas Cobranças
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  navigate(
                                    `/vendasrecorrentes/listagem/transacoes/${item.idBuyer}`
                                  );
                                }}
                                icon={<FaListAlt />}
                              >
                                Ver Transações
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })
                ) : (
                  <></>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </Select>
          </Flex>
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"85%"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner color={colors.VARIANT} size={"lg"} />
        </Flex>
      )}

      <ViewModalAssinaturas
        isOpen={openView}
        setIsOpen={setOpenView}
        item={itemToDetail}
      />
      <ModalUltimasCobrancas
        isOpen={openCobrancas}
        onClose={() => setOpenCobrancas(false)}
        idCustomer={itemToDetail.idBuyer}
        descricao={itemToDetail.plano?.nome}
      />
      <ModalCancelamentoAssinatura
        isOpen={openDelete}
        setIsOpen={setOpenDelete}
        /* sem idAssinatura (criacao que voltou erro do provedor) o cancelamento
           vai pelo id da linha - a core localiza a assinatura no provedor */
        id={itemToDetail.idAssinatura || itemToDetail.id}
      />
    </>
  );
}
export default TableVendasRecorrentes;
